/**
 * タイピングアニメーション初期化
 * テキストノードのみを対象に1文字ずつspanで囲う
 * 既存のHTMLタグ（spanなど）は構造を維持したまま処理する
 */
function initTypingAnimation() {
    const elements = document.querySelectorAll('.js--separate-span');
    if (!elements.length) return;

    elements.forEach(el => {
        let charIndex = 0; // 要素全体での文字インデックスを通算管理

        /**
         * ノードを再帰的に処理し、テキストノードのみ文字分割する
         * @param {Node} node - 処理対象ノード
         */
        function processNode(node) {
            if (node.nodeType === Node.TEXT_NODE) {
                // テキストノードの場合、1文字ずつspanに分割
                const text = node.textContent;
                if (!text) return;

                const fragment = document.createDocumentFragment();

                [...text].forEach(char => {
                    const span = document.createElement('span');
                    span.className = 'typing__char';
                    span.style.animationDelay = `${charIndex * 0.05}s`;
                    // 空白も幅を保持するためそのままセット
                    span.textContent = char;
                    fragment.appendChild(span);
                    charIndex++;
                });

                node.parentNode.replaceChild(fragment, node);

            } else if (node.nodeType === Node.ELEMENT_NODE) {
                // 要素ノードの場合、子ノードを再帰的に処理
                // childNodesはliveなのでスナップショットに変換してから処理
                [...node.childNodes].forEach(child => processNode(child));
            }
        }

        processNode(el);

        // アクセシビリティ: 読み上げ用にaria-labelで元テキストを保持
        el.setAttribute('aria-label', el.textContent);
    });
}
document.addEventListener('DOMContentLoaded', () => {
    initTypingAnimation();
});